import './App.scss';
import "./WebSmallComponents.scss";
import NCPRoutes from './ReUableComponents/Routes.jsx';
import "bootstrap/dist/css/bootstrap.css";
import { BrowserRouter } from 'react-router-dom';
function App() {
  return (
    <>
      <BrowserRouter>
        <NCPRoutes />
      </BrowserRouter>
    </>
  );
}

export default App;
